import Vue from 'vue'

const storeCache = {}

function createStore(name, data) {
	if (!storeCache[name]) {
		storeCache[name] = new (Vue.extend({
			data() {
				return data
			},
			
			methods: {
				commit(key, data) {
					this[key] = data;
				}
			}
		}))
	}
	return storeCache[name];
}

function updateState(name, ...params) {
	storeCache[name].commit.apply(storeCache[name], params);
}

function mapState(name, data) {
	const res = {};
	data.forEach(key => {
		res[key] = {
			get() {
				return storeCache[name][key];
			},
			set() {}
		}
	});
	return res;
}

export {createStore, mapState, updateState}